<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content flow-window">
    <div slot="header">
      <window-header cmp-title="Flow options" widget-name="flow-options"></window-header>
    </div>
    <div class="flex-full-height p-2">
      <div>
        <b-form-radio-group v-model="mode" :options="modes" class="mb-2" size="sm" >
        </b-form-radio-group>
      </div>
      <b-container fluid>
        <b-row v-for="(t,i) in uls_tables" :key="t.id">
          <b-col sm="2">
            <div class="w-100 h-100" :style="{'background-color': t.color}"></div>
          </b-col>
          <b-col sm="10">
            <b-form-checkbox
              v-model="values[i]"
              :value="true"
              :unchecked-value="false">
              {{t.label}}
            </b-form-checkbox>
          </b-col>

        </b-row>
      </b-container>
    </div>
    <window-footer></window-footer>
  </b-card>
</template>

<script>

  import WindowHeader from '../common/WindowHeader'
  import WindowFooter from '../common/WindowFooter'

  export default {
    name: 'FlowDataSettings',
    components: {WindowHeader, WindowFooter},
    data () {
      return {
        values: [],
        modes: [
          {
            text: 'Gas',
            value: 'gas',
          },
          {
            text: 'Water',
            value: 'water',
          }
        ],
        initalised: false
      }
    },
    props: {
      uls_tables: {
        default: () => []
      }
    },
    mounted () {
      this.uls_tables.forEach((t, i)=> {
        this.$set(this.values, i, !!t.checked)
      })

      this.initalised  = true
    },
    computed: {
      flow_uls_tables: {
        get() {
          return this.$store.getters['map/flow_uls_tables']
        },
        set(val) {
          return this.$store.commit('map/flow_uls_tables', val)
        }
      },
      mode: {
        get() {
          return this.$store.getters['map/flow_mode']
        },
        set(val) {
          return this.$store.commit('map/flow_mode', val)
        }
      }
    },
    watch: {
      values (val) {
        if (!this.initalised) {
          return
        }
        this.flow_uls_tables=this.uls_tables.filter((t, i) => val[i]).map(t => t.id).join(',')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/FlowDataSettings.vue